import React from 'react';
import { createRoot } from 'react-dom/client';

/** side effects */
import '@atlaskit/css-reset';

/** theme tokens */
// import '@atlaskit/tokens/css/atlassian-light.css';
// import '@atlaskit/tokens/css/atlassian-dark.css';

import '@/common/sentry';

import Root from './app';

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(<Root />);
